import Button from "./Button";

export function AddNewDealsButton({ onClick }) {
  return (
    <Button
      type="primary"
      label="Add new deal(s)"
      size="small"
      disabled={false}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
